import { PUBLIC_SITE_URL, PUBLIC_SITE_URL_DEV } from '../../../pure-js/libs/Consts'

// Production Firebase configuration
const FIREBASE_CONFIG_PROD = {
  apiKey: 'AIzaSyB8kFI2XkRifXqhdZwCdpluL18xjVKOjEE',
  authDomain: 'intraction-web.web.app',
  projectId: 'intraction-f177a',
  storageBucket: 'intraction-f177a.appspot.com',
  messagingSenderId: '10684929325',
  appId: '1:10684929325:web:e2a47886e4b8eb83a6efa4',
  measurementId: 'G-CVC20N6BPX'
}

// Development Firebase configuration
const FIREBASE_CONFIG_DEV = {
  apiKey: 'AIzaSyAGBUF72bEPy1ph6LC2X_O8YV-395qhqOc',
  authDomain: 'intraction-dev.firebaseapp.com',
  projectId: 'intraction-dev',
  storageBucket: 'intraction-dev.firebasestorage.app',
  messagingSenderId: '207647030478',
  appId: '1:207647030478:web:fe4e8c8fd911b8b07a249f',
  measurementId: 'G-8FYYGRWYGR'
}

// Environment configuration
export const ENV_CONFIG = {
  // Local development environment
  local: {
    apiUrl: 'http://localhost:3000',
    firebaseConfig: FIREBASE_CONFIG_DEV,
    functionsRegion: 'europe-west3',
    functionsProjectId: 'intraction-dev',
    publicSiteUrl: PUBLIC_SITE_URL_DEV
  },

  // Development environment (deployed from develop branch)
  development: {
    apiUrl: 'https://api.interax.com',
    firebaseConfig: FIREBASE_CONFIG_DEV,
    functionsRegion: 'europe-west3',
    functionsProjectId: 'intraction-dev',
    publicSiteUrl: PUBLIC_SITE_URL_DEV
  },

  // Production environment
  production: {
    apiUrl: 'https://api.interax.com',
    firebaseConfig: FIREBASE_CONFIG_PROD,
    functionsRegion: 'europe-west3',
    functionsProjectId: 'intraction-f177a',
    publicSiteUrl: PUBLIC_SITE_URL
  }
}

// Get current environment
export const getCurrentEnvironment = () => {
  // Check for explicit environment override
  const envOverride = import.meta.env.VITE_ENVIRONMENT

  if (envOverride === 'development' || envOverride === 'dev') {
    return ENV_CONFIG.development
  }

  const mode = import.meta.env.MODE || 'production'

  if (mode === 'development') {
    return ENV_CONFIG.local
  }

  return ENV_CONFIG.production
}

// Export current config
export const CURRENT_CONFIG = getCurrentEnvironment()
